import React from 'react';
import { toneFor, confidenceColors, useTheme } from '../lib/theme';

export function ConfidencePill({ confidence, className = '' }) {
  const { effective } = useTheme();
  const tone = toneFor(confidence);
  const { bg, fg } = confidenceColors(tone, effective === 'dark');
  const pct = Math.round(confidence * 100);

  return (
    <span
      data-testid="confidence-pill"
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold tabular-nums ${className}`}
      style={{ backgroundColor: bg, color: fg }}
    >
      {pct}%
    </span>
  );
}
